var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_488_3135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.35033 19.2573C7.35033 20.378 6.25713 20.6166 5.94034 20.6626C5.19964 20.6419 4.60361 20.021 4.60361 19.2573V1.87876H12.8438V0H3.68803C3.18264 0 2.77246 0.420842 2.77246 0.939379V19.2573C2.77246 21.0703 4.20991 22.5451 5.97697 22.5451H19.7106C21.4776 22.5451 22.9151 21.0703 22.9151 19.2573V17.8482H7.35033V19.2573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3371 11.2726C16.9756 11.2726 15.714 10.8311 14.6748 10.0852V15.9695L18.3371 13.1513L21.9994 15.9695V10.0852C20.9602 10.8311 19.6986 11.2726 18.3371 11.2726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3371 9.39379C20.8654 9.39379 22.915 7.29092 22.915 4.6969C22.915 2.10287 20.8654 0 18.3371 0C15.8089 0 13.7593 2.10287 13.7593 4.6969C13.7593 7.29092 15.8089 9.39379 18.3371 9.39379Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_488_3135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9737,
    height: 22.5451,
    fill: "white",
    transform: "translate(0.941406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.454023f347b76a9bdeaa26df08f1a5cd.svg";
export { ForwardRef as ReactComponent };